module.exports = __webpack_public_path__ + "media/images/missile_ic-386fd8a8544291f1c1be20814d4806cc.svg";